module.exports = __webpack_public_path__ + "media/images/redesign-images/about-us/ig/ig-12-7017774badab4b019a9c73947c2c9fde.jpg";